// ==========================================
// Route protégée (avec support admin)
// ==========================================

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface ProtectedRouteProps {
  requireAdmin?: boolean;
}

export default function ProtectedRoute({ requireAdmin = false }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Vérification admin si requis
  if (requireAdmin && !(user as any)?.is_admin) {
    return <Navigate to="/" replace />;
  }
  
  return <Outlet />;
}
